import type {ExtractPropsWithoutRef} from '@/types';

import {RatingBadge as UIRatingBadge} from '@travel-frontend/ui-components';

import {formatScore} from '@/components/RatingSnippet/utils';
import {testId} from '@/utils/testId';

type Props = ExtractPropsWithoutRef<'div'> & {
  score?: number;
  shouldShowMaxScore?: boolean;
};

export const Badge: React.FunctionComponent<Props> = ({
  score: rawScore,
  shouldShowMaxScore = true,
  ...restProps
}) => {
  if (rawScore === undefined) {
    return null;
  }
  const {scoreFormatted, scoreMax, sentiment} = formatScore(rawScore);

  return (
    <UIRatingBadge
      data-testid={testId('hotel-rating')}
      {...restProps}
      sentiment={sentiment}
    >
      {shouldShowMaxScore ? `${scoreFormatted} / ${scoreMax}` : scoreFormatted}
    </UIRatingBadge>
  );
};
